import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { RouterModule, Routes } from '@angular/router';
import { OwlModule } from 'ngx-owl-carousel';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { CountriesResolver } from 'src/app/shared/resolvers/countries.resolver';
import { LocationResolver } from 'src/app/shared/resolvers/location.resolver';
import { ReferralIdResolver } from 'src/app/shared/resolvers/referral-id.resolver';
import { CommonPipesModule } from 'src/app/_helper/pipes/common-pipes.module';
import { Presentation1Component } from './presentation/presentation1.component';
import { Presentation10Component } from './presentation10/presentation10.component';
import { Presentation11Component } from './presentation11/presentation11.component';
import { Presentation12Component } from './presentation12/presentation12.component';
import { Presentation13Component } from './presentation13/presentation13.component';
import { Presentation14Component } from './presentation14/presentation14.component';
import { Presentation15Component } from './presentation15/presentation15.component';
import { Presentation16Component } from './presentation16/presentation16.component';
import { Presentation17Component } from './presentation17/presentation17.component';
import { Presentation18Component } from './presentation18/presentation18.component';
import { Presentation19Component } from './presentation19/presentation19.component';
import { Presentation2Component } from './presentation2/presentation2.component';
import { Presentation20Component } from './presentation20/presentation20.component';
import { Presentation21Component } from './presentation21/presentation21.component';
import { Presentation22Component } from './presentation22/presentation22.component';
import { Presentation3Component } from './presentation3/presentation3.component';
import { Presentation4Component } from './presentation4/presentation4.component';
import { Presentation5Component } from './presentation5/presentation5.component';
import { Presentation6Component } from './presentation6/presentation6.component';
import { Presentation7Component } from './presentation7/presentation7.component';
import { Presentation8Component } from './presentation8/presentation8.component';
import { Presentation9Component } from './presentation9/presentation9.component';

const routes: Routes = [
  {
    path: '',
    resolve: {
      sponsorData: ReferralIdResolver,
      countriesData: CountriesResolver,
      locationData: LocationResolver,
    },
    children: [
      {
        path: 'presentation1',
        component: Presentation1Component,
      },
      { path: 'presentation2', component: Presentation2Component },
      { path: 'presentation3', component: Presentation3Component },
      { path: 'presentation4', component: Presentation4Component },
      { path: 'presentation5', component: Presentation5Component },
      { path: 'presentation6', component: Presentation6Component },
      { path: 'presentation7', component: Presentation7Component },
      { path: 'presentation8', component: Presentation8Component },
      { path: 'presentation9', component: Presentation9Component },
      { path: 'presentation10', component: Presentation10Component },
      { path: 'presentation11', component: Presentation11Component },
      { path: 'presentation12', component: Presentation12Component },
      { path: 'presentation13', component: Presentation13Component },
      { path: 'presentation14', component: Presentation14Component },
      { path: 'presentation15', component: Presentation15Component },
      { path: 'presentation16', component: Presentation16Component },
      { path: 'presentation17', component: Presentation17Component },
      { path: 'presentation18', component: Presentation18Component },
      { path: 'presentation19', component: Presentation19Component },
      { path: 'presentation20', component: Presentation20Component },
      { path: 'presentation21', component: Presentation21Component },
      { path: 'presentation22', component: Presentation22Component },
      {
        path: ':unknown',
        redirectTo: '/404',
      },
    ],
  },
];

@NgModule({
  declarations: [
    Presentation1Component,
    Presentation2Component,
    Presentation3Component,
    Presentation4Component,
    Presentation5Component,
    Presentation6Component,
    Presentation7Component,
    Presentation8Component,
    Presentation9Component,
    Presentation10Component,
    Presentation11Component,
    Presentation12Component,
    Presentation13Component,
    Presentation14Component,
    Presentation15Component,
    Presentation16Component,
    Presentation17Component,
    Presentation18Component,
    Presentation19Component,
    Presentation20Component,
    Presentation21Component,
    Presentation22Component,
  ],
  imports: [
    CommonModule,
    MatSliderModule,
    FormsModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    OwlModule,
    SlickCarouselModule,
    CarouselModule,
    MatIconModule,
    MatSelectModule,
    CommonPipesModule,
  ],
  providers: [CountriesResolver],
})
export class presentationModule {}
